/** @type {string} */
export const defaultCurrencyZeroPlaceholder = 'R$ 0,00'
